import { isArray, isEmpty } from 'lodash';
import { EMPTY_STRING } from '@common/constants';
import { User } from '@common/types';

export const getUserAvatar = (attachments: User['Attachments'] = {}) => {
  if (isEmpty(attachments)) return EMPTY_STRING;
  const avatar = (isArray(attachments) ? attachments : Object.values(attachments)).find(({ Subject }) => Subject === 'avatar');
  return avatar?.UrlThumbnail ?? avatar?.UrlOriginal ?? EMPTY_STRING;
};
